import { render, staticRenderFns } from "./set-status.html?vue&type=template&id=08ae9476&scoped=true&"
import script from "./set-status.js?vue&type=script&lang=js&"
export * from "./set-status.js?vue&type=script&lang=js&"
import style0 from "./set-status.scss?vue&type=style&index=0&id=08ae9476&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ae9476",
  null
  
)

export default component.exports